import type { FC, ReactNode } from 'react';
import { Tag } from '@carbon/react';
import type { DataTableColumnDef } from 'components/data-table';
import { EMPTY } from './types';
import type { PickerRow } from './record-kind-configs';
import type { PickerTableConfig } from './record-picker-table';
import styles from './related-items.module.scss';

// Not in RECORD_KIND_CONFIGS: those keys drive the related_items submit path; a workbook links through its own controller.

const text = (value: unknown): string => String(value ?? '').trim() || EMPTY;

// Sizes sum to 555; with the 48px select column that fills the 640 panel without sideways scroll.
const column = (
  id: string,
  header: string,
  size: number,
  render: (row: PickerRow) => ReactNode
): DataTableColumnDef<PickerRow> => ({
  id,
  header,
  size,
  cell: ({ row }) => render(row.original),
});

// All 198 rows share the same 53-char root; the leaf is the tract's folder.
const leaf = (path: string): string =>
  path.replace(/\/+$/, '').split('/').pop() ?? '';

export const DirectSupportTag: FC<{ direct?: boolean }> = ({ direct }) => {
  if (!direct) return null;
  return (
    <Tag type="green" size="sm" className={styles.fixedTag}>
      Direct support
    </Tag>
  );
};

const fileName = (row: PickerRow): ReactNode => (
  <>
    {text(row.fileName)}{' '}
    <DirectSupportTag direct={row.directSupport as boolean | undefined} />
  </>
);

export const EXTERNAL_TITLE_SUPPORT_PICKER: PickerTableConfig = {
  href: '/queries/external_title_supports',
  searchPlaceholder: 'Search by file name or folder…',
  columns: [
    column('fileName', 'File Name', 215, fileName),
    column('folder', 'Folder', 150, (row) => leaf(text(row.folder))),
    column('sheetCount', 'Sheets', 80, (row) => text(row.sheetCount)),
    column('extractedAt', 'Extracted', 110, (row) =>
      text(row.extractedAt).slice(0, 10)
    ),
  ],
  getRowId: (row) => String(row.id),
};
